var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"tips"},_vm._l((_vm.legends),function(item,index){return _c('span',{key:index,class:{'active': _vm.active == index},on:{"click":function($event){_vm.changeData(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{ref:"echarts",staticClass:"echarts"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1644c537","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/components/KLine.vue
// module id = null
// module chunks = 